import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

const createUpdateChatHistoryApi = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunction(data,apiConstants.TICKET.CREATE_UPDATE_CHAT_HISTORY)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default createUpdateChatHistoryApi;
